export class OptionData {
  value: string;
  label: string;
  ariaLabel: string;

  constructor(value: string, label: string, ariaLabel?: string) {
    this.value = value;
    this.label = label;
    this.ariaLabel = ariaLabel || label;
  }
}
